import { formatTimeSince } from "../dateUtils";
import { useTranslation } from "react-i18next";
import { AlertTypeIcon } from "./alert-type-icon";
import { Link } from "react-router-dom";
import { NotificationModel } from "app/notifications/model/notification.model";

interface AlertItemProps {
    notification: NotificationModel;
    viewed: (notification: NotificationModel) => void;
    onClick: (notification: NotificationModel) => void;
}

export function AlertItem(props: AlertItemProps) {
    const { t } = useTranslation();
    const departmentsCount = props.notification
        .departments
        .length;

    const viewed = props.notification.viewed;
    const classNameItem = `d-flex flex-stack py-4 mt-1 ${viewed ? "" : "bg-light"}`;

    return (
        <>
            <Link to={`/notifications/center/${props.notification.id}`} onClick={() => props.onClick(props.notification)}>
                <div className={classNameItem} onMouseEnter={() => {
                    if (props.notification.viewed) return;
                    props.viewed(props.notification)
                    props.notification.viewed = true;
                }
                }>
                    <div className="d-flex align-items-center">
                        {
                            !props.notification.read &&
                            <span className="bullet bullet-dot bg-success h-6px w-6px translate-middle start-50 animation-blink align-self-center ms-2"></span>
                        }
                        <div className="symbol symbol-35px me-4 ms-2">
                            <AlertTypeIcon notificationType={props.notification.type} />
                        </div>
                        <div className="fs-6 text-gray-800 text-hover-primary fw-bold text-center">
                            {
                                props.notification.read ? (
                                    <>{props.notification.title}</>
                                ) : (
                                    <strong>{props.notification.title}</strong>
                                )
                            }
                        </div>
                    </div>
                    <span className="badge badge-light fs-8">{formatTimeSince(props.notification.date, t)}</span>
                </div>
            </Link>
        </>
    );
}